import React from 'react';
import { FilterableRisk } from './sections/risk-dashboard-filter.helper';
import { EvaluationModel } from './sections/risk-map.utils';
import { FilterCategory, FilterUIStateUpdate } from '@components-clean/core/filter-ui/action-bar/shared/interfaces';
import { NullableStudy } from '@contexts/local-state-context';
import { CompleteRiskFields } from '@queries/generated/fragments.generated';

export interface IRiskDashboardContext {
    study: NullableStudy | undefined;
    risks: CompleteRiskFields[];
    filteredRisks: CompleteRiskFields[];
    filterableRisks: FilterableRisk[];
    categories: FilterCategory[];
    screenTrackedChanges: FilterUIStateUpdate[];
    includeObsolete: boolean;
    filterVersion: number;
    includeDetectability: boolean;
    evaluationModelId: string | undefined;
    evaluationModel: EvaluationModel | undefined;
}

export const RiskDashboardContext = React.createContext<IRiskDashboardContext>({
    study: undefined,
    risks: [],
    filteredRisks: [],
    filterableRisks: [],
    categories: [],
    screenTrackedChanges: [],
    includeObsolete: false,
    filterVersion: 0,
    includeDetectability: false,
    evaluationModelId: undefined,
    evaluationModel: undefined,
});
